<template>
  <div class="min-h-screen">
    <HeroSection />
    <PreviewSection />
    <FeaturesSection />
    <CTASection />
  </div>
</template>

<script setup>
import CTASection from '~/components/landing/CTASection.vue';
import FeaturesSection from '~/components/landing/FeaturesSection.vue';
import HeroSection from '~/components/landing/HeroSection.vue';
import PreviewSection from '~/components/landing/PreviewSection.vue';

definePageMeta({
  layout: 'landing',
  auth: false,
});

useHead({
  title: 'Bruce',
  description: 'Bring your old documents up to date—instantly.',
});
</script>
